import Api from '../../../util/Api'

export default function getInitState() {
  return {
    formIsOpen: false,
    gridIsOpen: true,
    additionalTableConfig: {
      server_mode: false,
      show_reset_button: false,
      global_search: {
        visibility: false,
      },
    },
    actions: [
        {
            btn_text: '<i class="fas fa-plus"></i> Magisztrális sablon hozzáadása',
            event_name: "customClick",
            class: "btn btn-success",
            event_payload: 'newTemplate'
        }
    ],
    formActions: [
        {
            btn_text: '<i class="fa fa-backward"></i> Vissza',
            event_name: "customClick",
            class: "btn btn-warning mx-1",
            event_payload: 'backToGrid'
        },
        {
            btn_text: '<i class="fas fa-trash"></i> Reset',
            event_name: "customClick",
            class: "btn btn-secondary mx-1",
            event_payload: 'resetForm'
        }
    ],
    rowActions: [
        {
            btn_text: '<i class="fas fa-arrow-right"></i>',
            title: 'Kiválasztás',
            event_name: "customClick",
            class: "btn btn-outline-success",
            event_payload: 'selectRow'
        },
        {
            btn_text: '<i class="fas fa-edit"></i>',
            title: 'Szerkesztés',
            event_name: "customClick",
            class: "btn btn-outline-primary",
            event_payload: 'modifyRow'
        },
        {
            btn_text: '<i class="fas fa-trash"></i>',
            title: 'Törlés',
            event_name: "customClick",
            class: "btn btn-outline-danger",
            event_payload: 'deleteRow'
        },
        {
            btn_text: '<i class="fas fa-undo"></i>',
            title: 'Visszaállítás',
            event_name: "customClick",
            class: "btn btn-outline-warning",
            seeCaseOfDeleted: true,
            event_payload: 'unDeleteRow'
        }
    ],
    headerFields: [
        {
            name: "id",
            label: "Azonosító",
            visibility: false,
            formVisible: false,
        },
        {
            name: "doctorId",
            label: "Orvos azonosító",
            visibility: false,
            formVisible: false,
        },
        {
            name: "templateName",
            label: "Sablon neve",
            filter: {
                type: "simple",
            },
            visibility: true,
            sort: true,
            formVisible: true,
            formSize: 3,
            formType: "text",
            formRequired: true
        },
        {
            name: "productName",
            label: "Készítmény neve",
            filter: {
                type: "simple",
            },
            visibility: true,
            sort: true,
            formVisible: true,
            formSize: 3,
            formType: "text",
            formRequired: true
        },
        {
            name: "note",
            label: "Megjegyzés",
            visibility: true,
            formVisible: true,
            formSize: 6,
            formType: "text"
        },
        {
            name: "productDescription",
            label: "Összetevők",
            visibility: false,
            formVisible: true,
            formSize: 6,
            formType: "textarea",
            formRequired: true
        },
        {
            name: "preparation",
            label: "Elkészítés",
            visibility: false,
            formVisible: true,
            formSize: 6,
            formType: "textarea",
            formRequired: true
        },
        {
            name: "dosage",
            label: "Adagolás",
            visibility: false,
            formVisible: true,
            formSize: 6,
            formType: "text",
            formRequired: true
        },
        {
            name: "medicalInstruction",
            label: "Orvosi utasítás",
            visibility: false,
            formVisible: true,
            formSize: 6,
            formType: "text",
            formRequired: true
        },
        {
            name: "items",
            label: "Termékek",
            visibility: false,
            formVisible: false,
            formSize: 12,
            formType: "dynamicListInput",
            dynamicListInputConfig: {
                inputFields: [
                    {
                        name: "termekId",
                        label: "Termék",
                        formRequired: false,
                        formType: "select",
                        selectOptions: {
                            apiCallback: Api.getMagisProductByFilter,
                            formatText: function(val){
                                return val.text + ' (' + val.kiszereles + ')';
                            },
                            formatOption: function(val){
                                return val.text + ' (' + val.kiszereles + ')';
                            },
                            minimumInputLength: 3,
                            searchOnServer: true,
                            filteredAttr: 'text',
                            locale: {
                                searchPlaceholder: 'Keresés...',
                                noResults: 'Nincs találat'
                            }
                        },
                        formSize: 6
                    },
                    {
                        name: "mennyiseg",
                        label: "Mennyiség",
                        formRequired: false,
                        formType: "number",
                        formSize: 3,
                        numberStep: 0.1
                    },
                    {
                        name: "mennyisegiEgyseg",
                        label: "Mennyiségi egység",
                        formRequired: false,
                        formType: "select",
                        selectOptions: {
                            apiCallback: Api.getFelirasMennyisegiEgysegeList,
                            formatText: function (val) {
                                return val.text;
                            },
                            formatOption: function (val) {
                                return val.text;
                            },
                            minimumInputLength: 0,
                            searchOnServer: false,
                            filteredAttr: 'text',
                            returnValue: 'eesztId',
                            locale: {
                                searchPlaceholder: 'Keresés...',
                                noResults: 'Nincs találat'
                            }
                        },
                        formSize: 3
                    },
                ],
                rowCountPerPage: 5,
                label: 'Termékek'
            }
        },
        {
            name: "buttons",
            label: "Opciók",
            sort: false,
            formVisible: false
        }
    ],
    }
  }
